import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export const STREAMING_SERVICE_DISPLAY_QUERY_KEY = ['streaming-service-display'] as const

/**
 * Service IDs that are displayed on the Streaming page (Streaming control).
 * Only these services appear as filter cards. When null (loading), consumer may show all or loading state.
 * When empty array, no service filter cards (only "All").
 */
export function useStreamingServiceDisplay() {
  const { data: displayedIds, isLoading } = useQuery({
    queryKey: STREAMING_SERVICE_DISPLAY_QUERY_KEY,
    queryFn: async (): Promise<string[]> => {
      try {
        const { data, error } = await supabase
          .from('streaming_service_display')
          .select('service_id')
          .eq('is_displayed', true)
        if (error) {
          console.warn('[useStreamingServiceDisplay]', error.message)
          return []
        }
        return (data ?? []).map((r) => r.service_id)
      } catch (e) {
        console.warn('[useStreamingServiceDisplay]', e)
        return []
      }
    },
    staleTime: 60_000,
  })
  return {
    displayedServiceIds: isLoading ? null : (displayedIds ?? []),
    isLoading,
  }
}
